import { PermissionSet, usePermission } from '@context'

export const useAllowUpload = () => usePermission(PermissionSet.FILES_UPLOAD)
